export enum Measurement {
  G = 'grams',
  MG = 'milligrams',
  MCG = 'micrograms',
  U = 'units',
  D = 'dose'
}
